import { render, staticRenderFns } from "./adv.vue?vue&type=template&id=361c3afc&"
import script from "./adv.vue?vue&type=script&lang=js&"
export * from "./adv.vue?vue&type=script&lang=js&"
import style0 from "./adv.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports